import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BrowserService {
  constructor() {}

  isOnMobile(): boolean {
    const width = window.innerWidth;
    return width <= 768; // global-variables.scss
  }
}
